import { BlendMode } from '@website-builder/model/style/blend-mode';

export class ImageStyle {
  border = '';
  transition = '';
  blendMode: BlendMode;
  breakpoint: string;
  parallaxValues = [];

  static normalize(styles: Partial<ImageStyle>): ImageStyle {
    const pureStyles = new ImageStyle();

    pureStyles.border = styles.border ?? pureStyles.border;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.blendMode = styles.blendMode ?? pureStyles.blendMode;
    pureStyles.breakpoint = styles.breakpoint ?? pureStyles.breakpoint;
    pureStyles.parallaxValues = styles.parallaxValues ?? pureStyles.parallaxValues;

    return pureStyles;
  }
}
